import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Check from '@wix/da-ds/pkg/Icons/Check';
import Error from '@wix/da-ds/pkg/Icons/24x24/Error';
import SystemNotification from '../../SystemNotification';
import Notification from '../Notification';
export const GenericNotification = ({ id , queueName , message , messageLocaleKey , messageLocaleOptions , isError =false , cardProps ={}  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(Notification, {
        id: id,
        queueName: queueName,
        cardComponent: SystemNotification,
        cardProps: _object_spread({
            iconComponent: isError ? Error : Check,
            isError
        }, cardProps)
    }, message !== null && message !== void 0 ? message : t(messageLocaleKey !== null && messageLocaleKey !== void 0 ? messageLocaleKey : '', messageLocaleOptions));
};
GenericNotification.displayName = 'GenericNotification';
export default GenericNotification;
